export default __webpack_public_path__ + "static/media/pets.09aa9e5e.svg";